<template>
  <v-container>
    <v-row class="text-center">
      <v-col>
        <v-btn color="primary1" dark @click="newCat = true">
          <v-icon left>mdi-plus</v-icon>NEW CATEGORY
        </v-btn>
      </v-col>
      <v-col>
        <v-row>
          <v-col>
            <p class="overline">TOTAL CATEGORY {{ CATEGORY.length }}</p>
          </v-col>
          <v-col>
            <v-btn icon @click="getCat">
              <v-icon>mdi-sync</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Search"
      single-line
      hide-details
    ></v-text-field>
    <br />
    <v-data-table
      :headers="headers"
      :items="CATEGORY"
      :search="search"
      :items-per-page="10"
      class="elevation-1"
    >
      <template v-slot:item.id="{ item }">
        <v-icon color="warning" class="mr-2" @click="EditCatItem(item)">mdi-pencil</v-icon>
        <v-icon color="error" @click="removeCat(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>
    <v-dialog v-model="editCat" persistent scrollable max-width="50%">
      <v-card>
        <v-container>
          <v-text-field label="Name" required v-model="editData.name"></v-text-field>
        </v-container>
        <v-card-actions>
          <v-row>
            <v-col>
              <v-btn color="error" block @click="editCat = false">Close</v-btn>
            </v-col>

            <v-col>
              <v-btn color="green" dark block @click="updateCat">UPDATE</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newCat" persistent scrollable max-width="50%">
      <v-card>
        <v-container>
          <v-text-field label="Name" required v-model="category_name"></v-text-field>
        </v-container>
        <v-card-actions>
          <v-row>
            <v-col>
              <v-btn color="error" block @click="newCat = false">Close</v-btn>
            </v-col>

            <v-col>
              <v-btn color="green" dark block @click="addcategory">ADD</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Item Name",
          align: "start",
          value: "name"
        },
        {
          text: "Action",
          align: "center",
          value: "id"
        }
      ],
      catBox: false,
      newCat: false,
      editCat: false,
      category_name: "",
      editData: {
        id: "",
        name: ""
      }
    };
  },
  computed: {
    ...mapGetters(["CATEGORY"])
  },
  methods: {
    ...mapActions([
      "GET_CATEGORY",
      "NEW_CATEGORY",
      "UPDATE_CATEGORY",
      "DELETE_CATEGORY"
    ]),
    getCat() {
      this.$store.commit("SET_LOADING", true);
      this.GET_CATEGORY().then(() => {
        this.$store.commit("SET_LOADING", false);
      });
    },
    EditCatItem(item) {
      this.editData = {
        id: item.id,
        name: item.name,
        v_id: item.v_id,
        v_name: item.v_name
      };
      this.editCat = true;
    },
    updateCat() {
      this.$store.commit("SET_LOADING", true);
      this.editCat = false;
      if (this.editData.id != "" && this.editData.name != "") {
        this.UPDATE_CATEGORY(this.editData).then(() => {
          this.$store.commit("SET_LOADING", false);
        });
      }
    },
    removeCat(item) {
      this.$store.commit("SET_LOADING", true);
      this.DELETE_CATEGORY({ id: item.id }).then(() => {
        this.$store.commit("SET_LOADING", false);
      });
    },
    addcategory() {
      if (this.category_name != "") {
        this.$store.commit("SET_LOADING", true);
        this.newCat = false;
        this.NEW_CATEGORY({ name: this.category_name }).then(() => {
          this.category_name = "";
          this.$store.commit("SET_LOADING", false);
        });
      }
    }
  }
};
</script>

<style></style>
